<template>
  <div>
    <quiz
      type="session"
      :send="send"
      :get="get"
      :redirect="successRedirect"
    />
  </div>
</template>


<script>
import quizAPI from "../../../api/quizAPI";
import {ROUTES} from "../../../router";
import quiz from "../common/quiz";
import common from "../../../helpers/common";

export default {
  components: {
    quiz
  },
  data() {
    return {
      attendeeId: this.$route.params.attendeeId,
      sessionId: this.$route.params.sessionId,
      successRedirect: {
        name: 'Session Evaluation',
        params: {
          attendeeId: this.$route.params.attendeeId,
          sessionId: this.$route.params.sessionId,
        },
        query: {back: this.$route.query.back || this.$route.name}
      }
    }
  },
  mounted() {
    common.setHeaderText('Session Quiz');
  },
  methods: {
    get() {
      return quizAPI.fetch(this.attendeeId, this.sessionId);
    },

    send(data) {
      return quizAPI.send(this.attendeeId, this.sessionId, data);
    },
  }
}
</script>